import { InventoryStockLevelsDTO } from '../dto/InventoryStockLevelsDTO';
import { InventoryStockLevels } from '@domain/inventory/models/InventoryStockLevels';

export class InventoryStockLevelsMapper {
  static toModel(dto: InventoryStockLevelsDTO): InventoryStockLevels {
    return {
      inStock: dto.inStock,
      lowStock: dto.lowStock,
      outOfStock: dto.outOfStock,
      total: dto.total,
    };
  }
}
